var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2954 5.875C17.4433 5.875 14.6553 6.72074 12.2838 8.30527C9.91243 9.8898 8.06414 12.142 6.97269 14.7769C5.88125 17.4119 5.59568 20.3114 6.15209 23.1086C6.7085 25.9059 8.08191 28.4754 10.0986 30.4921C12.1154 32.5088 14.6848 33.8822 17.4821 34.4387C20.2794 34.9951 23.1788 34.7095 25.8138 33.6181C28.4488 32.5266 30.7009 30.6783 32.2855 28.3069C33.87 25.9355 34.7157 23.1475 34.7157 20.2954C34.7155 16.4709 33.1961 12.8032 30.4919 10.0989C27.7876 7.39461 24.1198 5.87524 20.2954 5.875Z",
    stroke: "#666666",
    strokeWidth: 2.9375,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0537 31.0537L41.1247 41.1247",
    stroke: "#666666",
    strokeWidth: 2.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f4767e9f267d1e5495270fd99f2e01ab.svg";
export { ForwardRef as ReactComponent };